export const BottomNavigation = () => import('../../../../components/layout/BottomNavigation.vue' /* webpackChunkName: "components/bottom-navigation" */).then(c => wrapFunctional(c.default || c))
export const NavBar = () => import('../../../../components/layout/NavBar.vue' /* webpackChunkName: "components/nav-bar" */).then(c => wrapFunctional(c.default || c))
export const PageTitle = () => import('../../../../components/layout/PageTitle.vue' /* webpackChunkName: "components/page-title" */).then(c => wrapFunctional(c.default || c))
export const AbSelectorButton = () => import('../../../../components/AbSelectorButton.vue' /* webpackChunkName: "components/ab-selector-button" */).then(c => wrapFunctional(c.default || c))
export const AbSubscriptionCard = () => import('../../../../components/AbSubscriptionCard.vue' /* webpackChunkName: "components/ab-subscription-card" */).then(c => wrapFunctional(c.default || c))
export const AbSubscriptionTable = () => import('../../../../components/AbSubscriptionTable.vue' /* webpackChunkName: "components/ab-subscription-table" */).then(c => wrapFunctional(c.default || c))
export const AbSubscriptionUsp = () => import('../../../../components/AbSubscriptionUsp.vue' /* webpackChunkName: "components/ab-subscription-usp" */).then(c => wrapFunctional(c.default || c))
export const InformationCard = () => import('../../../../components/InformationCard.vue' /* webpackChunkName: "components/information-card" */).then(c => wrapFunctional(c.default || c))
export const PillButton = () => import('../../../../components/PillButton.vue' /* webpackChunkName: "components/pill-button" */).then(c => wrapFunctional(c.default || c))
export const SelectorButton = () => import('../../../../components/SelectorButton.vue' /* webpackChunkName: "components/selector-button" */).then(c => wrapFunctional(c.default || c))
export const SubscriptionCard = () => import('../../../../components/SubscriptionCard.vue' /* webpackChunkName: "components/subscription-card" */).then(c => wrapFunctional(c.default || c))
export const WpModal = () => import('../../../../components/WpModal.vue' /* webpackChunkName: "components/wp-modal" */).then(c => wrapFunctional(c.default || c))
export const WpInput = () => import('../../../../components/wpInput.vue' /* webpackChunkName: "components/wp-input" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
